import SectionHeading from "@/components/base/SectionHeading";
import { relatedGenres } from "@/mocks/homeContent";

export default function RelatedGenres() {
  return (
    <section id="related" className="bg-background-50 py-16 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <SectionHeading kicker="More Like This" title={relatedGenres.title} desc={relatedGenres.desc} />

        <div className="mt-10 grid gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {relatedGenres.list.map((item) => (
            <article
              key={item.title}
              className="flex h-full flex-col rounded-lg border border-background-200/70 bg-background-100 p-5 transition-colors hover:border-accent-300"
            >
              <span className="flex h-12 w-12 items-center justify-center rounded-md bg-accent-100 text-accent-800">
                <i className={`${item.icon} text-2xl`}></i>
              </span>
              <h3 className="mt-4 font-heading text-base font-semibold text-foreground-950">{item.title}</h3>
              <p className="mt-2 flex-1 text-sm leading-relaxed text-foreground-600">{item.desc}</p>
              <div className="mt-4 flex flex-wrap gap-2">
                {item.tags.map((tag) => (
                  <span
                    key={tag}
                    className="rounded-full border border-secondary-200 bg-secondary-50 px-2.5 py-0.5 text-[11px] text-secondary-800"
                  >
                    {tag}
                  </span>
                ))}
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}